import * as Yup from "yup";

export const ProductValidation = Yup.object().shape({
  itemCode: Yup.string().required("Product Code is required"),
  name: Yup.string().required("Product name is required"),
  amount: Yup.number(),
  meterOrSuit: Yup.number()
    .max(99999999, "Must be less then 99999999")
    .required("Quantity is required"),
  unitPurchasePrice: Yup.number()
    .min(0, "Must be greater then 0")
    .max(9999999, "Must be less then 9999999")
    .required("Unit purchase price is required"),
});
